
const bancos = [
  {
      'id':1,
      'nome':'001 - BANCO DO BRASIL S/A',
      'ativo':true,
      'paymentMethod': 'BB_TRANSFER'
   },
   {
      'id':2,
      'nome':'002 - BANCO CENTRAL DO BRASIL',
      'ativo':false
   },
   {
      'id':3,
      'nome':'003 - BANCO DA AMAZONIA S.A',
      'ativo':false
   },
   {
      'id':4,
      'nome':'004 - BANCO DO NORDESTE DO BRASIL S.A',
      'ativo':false
   },
   {
      'id':7,
      'nome':'007 - BANCO NAC DESENV. ECO. SOCIAL S.A',
      'ativo':false
   },
   {
      'id':8,
      'nome':'008 - BANCO MERIDIONAL DO BRASIL',
      'ativo':false
   },
   {
      'id':20,
      'nome':'020 - BANCO DO ESTADO DE ALAGOAS S.A',
      'ativo':false
   },
   {
      'id':21,
      'nome':'021 - BANCO DO ESTADO DO ESPIRITO SANTO S.A',
      'ativo':false
   },
   {
      'id':22,
      'nome':'022 - BANCO DE CREDITO REAL DE MINAS GERAIS SA',
      'ativo':false
   },
   {
      'id':24,
      'nome':'024 - BANCO DO ESTADO DE PERNAMBUCO',
      'ativo':false
   },
   {
      'id':25,
      'nome':'025 - BANCO ALFA S/A',
      'ativo':false
   },
   {
      'id':26,
      'nome':'026 - BANCO DO ESTADO DO ACRE S.A',
      'ativo':false
   },
   {
      'id':27,
      'nome':'027 - BANCO DO ESTADO DE SANTA CATARINA S.A',
      'ativo':false
   },
   {
      'id':28,
      'nome':'028 - BANCO DO ESTADO DA BAHIA S.A',
      'ativo':false
   },
   {
      'id':29,
      'nome':'029 - BANCO DO ESTADO DO RIO DE JANEIRO S.A',
      'ativo':false
   },
   {
      'id':30,
      'nome':'030 - BANCO DO ESTADO DA PARAIBA S.A',
      'ativo':false
   },
   {
      'id':31,
      'nome':'031 - BANCO DO ESTADO DE GOIAS S.A',
      'ativo':false
   },
   {
      'id':32,
      'nome':'032 - BANCO DO ESTADO DO MATO GROSSO S.A.',
      'ativo':false
   },
   {
      'id':33,
      'nome':'033 - BANCO DO ESTADO DE SAO PAULO S.A',
      'ativo':false
   },
   {
      'id':34,
      'nome':'034 - BANCO DO ESADO DO AMAZONAS S.A',
      'ativo':false
   },
   {
      'id':35,
      'nome':'035 - BANCO DO ESTADO DO CEARA S.A',
      'ativo':false
   },
   {
      'id':36,
      'nome':'036 - BANCO DO ESTADO DO MARANHAO S.A',
      'ativo':false
   },
   {
      'id':37,
      'nome':'037 - BANCO DO ESTADO DO PARA S.A',
      'ativo':false
   },
   {
      'id':38,
      'nome':'038 - BANCO DO ESTADO DO PARANA S.A',
      'ativo':false
   },
   {
      'id':39,
      'nome':'039 - BANCO DO ESTADO DO PIAUI S.A',
      'ativo':false
   },
   {
      'id':41,
      'nome':'041 - BANCO DO ESTADO DO RIO GRANDE DO SUL S.A',
      'ativo':false
   },
   {
      'id':47,
      'nome':'047 - BANCO DO ESTADO DE SERGIPE S.A',
      'ativo':false
   },
   {
      'id':48,
      'nome':'048 - BANCO DO ESTADO DE MINAS GERAIS S.A',
      'ativo':false
   },
   {
      'id':59,
      'nome':'059 - BANCO DO ESTADO DE RONDONIA S.A',
      'ativo':false
   },
   {
      'id':70,
      'nome':'070 - BANCO DE BRASILIA S.A',
      'ativo':false
   },
   {
      'id':104,
      'nome':'104 - CAIXA ECONOMICA FEDERAL',
      'ativo':true,
      'paymentMethod': 'CEF_TRANSFER'
   },
   {
      'id':106,
      'nome':'106 - BANCO ITABANCO S.A.',
      'ativo':false
   },
   {
      'id':107,
      'nome':'107 - BANCO BBM S.A',
      'ativo':false
   },
   {
      'id':109,
      'nome':'109 - BANCO CREDIBANCO S.A',
      'ativo':false
   },
   {
      'id':116,
      'nome':'116 - BANCO B.N.L DO BRASIL S.A',
      'ativo':false
   },
   {
      'id':148,
      'nome':'148 - MULTI BANCO S.A',
      'ativo':false
   },
   {
      'id':151,
      'nome':'151 - CAIXA ECONOMICA DO ESTADO DE SAO PAULO',
      'ativo':false
   },
   {
      'id':153,
      'nome':'153 - CAIXA ECONOMICA DO ESTADO DO R.G.SUL',
      'ativo':false
   },
   {
      'id':165,
      'nome':'165 - BANCO NORCHEM S.A',
      'ativo':false
   },
   {
      'id':166,
      'nome':'166 - BANCO INTER-ATLANTICO S.A',
      'ativo':false
   },
   {
      'id':168,
      'nome':'168 - BANCO C.C.F. BRASIL S.A',
      'ativo':false
   },
   {
      'id':175,
      'nome':'175 - CONTINENTAL BANCO S.A',
      'ativo':false
   },
   {
      'id':184,
      'nome':'184 - BBA - CREDITANSTALT S.A',
      'ativo':false
   },
   {
      'id':199,
      'nome':'199 - BANCO FINANCIAL PORTUGUES',
      'ativo':false
   },
   {
      'id':200,
      'nome':'200 - BANCO FRICRISA AXELRUD S.A',
      'ativo':false
   },
   {
      'id':201,
      'nome':'201 - BANCO AUGUSTA INDUSTRIA E COMERCIAL S.A',
      'ativo':false
   },
   {
      'id':204,
      'nome':'204 - BANCO S.R.L S.A',
      'ativo':false
   },
   {
      'id':205,
      'nome':'205 - BANCO SUL AMERICA S.A',
      'ativo':false
   },
   {
      'id':206,
      'nome':'206 - BANCO MARTINELLI S.A',
      'ativo':false
   },
   {
      'id':208,
      'nome':'208 - BANCO PACTUAL S.A',
      'ativo':false
   },
   {
      'id':210,
      'nome':'210 - DEUTSCH SUDAMERIKANICHE BANK AG',
      'ativo':false
   },
   {
      'id':211,
      'nome':'211 - BANCO SISTEMA S.A',
      'ativo':false
   },
   {
      'id':212,
      'nome':'212 - BANCO ORIGINAL S.A',
      'ativo':true,
      'paymentMethod': 'ORIGINAL_TRANSFER'
   },
   {
      'id':213,
      'nome':'213 - BANCO ARBI S.A',
      'ativo':false
   },
   {
      'id':214,
      'nome':'214 - BANCO DIBENS S.A',
      'ativo':false
   },
   {
      'id':215,
      'nome':'215 - BANCO AMERICA DO SUL S.A',
      'ativo':false
   },
   {
      'id':216,
      'nome':'216 - BANCO REGIONAL MALCON S.A',
      'ativo':false
   },
   {
      'id':217,
      'nome':'217 - BANCO AGROINVEST S.A',
      'ativo':false
   },
   {
      'id':218,
      'nome':'218 - BANCO BS2 S.A.',
      'ativo':true,
      'paymentMethod': 'BS2_TRANSFER'
   },
   {
      'id':219,
      'nome':'219 - BANCO DE CREDITO DE SAO PAULO S.A',
      'ativo':false
   },
   {
      'id':220,
      'nome':'220 - BANCO CREFISUL',
      'ativo':false
   },
   {
      'id':221,
      'nome':'221 - BANCO GRAPHUS S.A',
      'ativo':false
   },
   {
      'id':222,
      'nome':'222 - BANCO AGF BRASIL S. A.',
      'ativo':false
   },
   {
      'id':223,
      'nome':'223 - BANCO INTERUNION S.A',
      'ativo':false
   },
   {
      'id':224,
      'nome':'224 - BANCO FIBRA S.A',
      'ativo':false
   },
   {
      'id':225,
      'nome':'225 - BANCO BRASCAN S.A',
      'ativo':false
   },
   {
      'id':228,
      'nome':'228 - BANCO ICATU S.A',
      'ativo':false
   },
   {
      'id':229,
      'nome':'229 - BANCO CRUZEIRO S.A',
      'ativo':false
   },
   {
      'id':230,
      'nome':'230 - BANCO BANDEIRANTES S.A',
      'ativo':false
   },
   {
      'id':231,
      'nome':'231 - BANCO BOAVISTA S.A',
      'ativo':false
   },
   {
      'id':232,
      'nome':'232 - BANCO INTERPART S.A',
      'ativo':false
   },
   {
      'id':233,
      'nome':'233 - BANCO MAPPIN S.A',
      'ativo':false
   },
   {
      'id':234,
      'nome':'234 - BANCO LAVRA S.A.',
      'ativo':false
   },
   {
      'id':235,
      'nome':'235 - BANCO LIBERAL S.A',
      'ativo':false
   },
   {
      'id':236,
      'nome':'236 - BANCO CAMBIAL S.A',
      'ativo':false
   },
   {
      'id':237,
      'nome':'237 - BANCO BRADESCO S.A',
      'ativo':true,
      'paymentMethod': 'BRADESCO_TRANSFER'
   },
   {
      'id':239,
      'nome':'239 - BANCO BANCRED S.A',
      'ativo':false
   },
   {
      'id':240,
      'nome':'240 - BANCO DE CREDITO REAL DE MINAS GERAIS S.',
      'ativo':false
   },
   {
      'id':241,
      'nome':'241 - BANCO CLASSICO S.A',
      'ativo':false
   },
   {
      'id':242,
      'nome':'242 - BANCO EUROINVEST S.A',
      'ativo':false
   },
   {
      'id':243,
      'nome':'243 - BANCO STOCK S.A',
      'ativo':false
   },
   {
      'id':244,
      'nome':'244 - BANCO CIDADE S.A',
      'ativo':false
   },
   {
      'id':245,
      'nome':'245 - BANCO EMPRESARIAL S.A',
      'ativo':false
   },
   {
      'id':246,
      'nome':'246 - BANCO ABC ROMA S.A',
      'ativo':false
   },
   {
      'id':247,
      'nome':'247 - BANCO OMEGA S.A',
      'ativo':false
   },
   {
      'id':249,
      'nome':'249 - BANCO INVESTCRED S.A',
      'ativo':false
   },
   {
      'id':250,
      'nome':'250 - BANCO SCHAHIN CURY S.A',
      'ativo':false
   },
   {
      'id':251,
      'nome':'251 - BANCO SAO JORGE S.A.',
      'ativo':false
   },
   {
      'id':252,
      'nome':'252 - BANCO FININVEST S.A',
      'ativo':false
   },
   {
      'id':254,
      'nome':'254 - BANCO PARANA BANCO S.A',
      'ativo':false
   },
   {
      'id':255,
      'nome':'255 - MILBANCO S.A.',
      'ativo':false
   },
   {
      'id':256,
      'nome':'256 - BANCO GULVINVEST S.A',
      'ativo':false
   },
   {
      'id':258,
      'nome':'258 - BANCO INDUSCRED S.A',
      'ativo':false
   },
   {
      'id':261,
      'nome':'261 - BANCO VARIG S.A',
      'ativo':false
   },
   {
      'id':262,
      'nome':'262 - BANCO BOREAL S.A',
      'ativo':false
   },
   {
      'id':263,
      'nome':'263 - BANCO CACIQUE',
      'ativo':false
   },
   {
      'id':264,
      'nome':'264 - BANCO PERFORMANCE S.A',
      'ativo':false
   },
   {
      'id':265,
      'nome':'265 - BANCO FATOR S.A',
      'ativo':false
   },
   {
      'id':266,
      'nome':'266 - BANCO CEDULA S.A',
      'ativo':false
   },
   {
      'id':267,
      'nome':'267 - BANCO BBM-COM.C.IMOB.CFI S.A.',
      'ativo':false
   },
   {
      'id':275,
      'nome':'275 - BANCO REAL S.A',
      'ativo':false
   },
   {
      'id':277,
      'nome':'277 - BANCO PLANIBANC S.A',
      'ativo':false
   },
   {
      'id':282,
      'nome':'282 - BANCO BRASILEIRO COMERCIAL',
      'ativo':false
   },
   {
      'id':291,
      'nome':'291 - BANCO DE CREDITO NACIONAL S.A',
      'ativo':false
   },
   {
      'id':294,
      'nome':'294 - BCR - BANCO DE CREDITO REAL S.A',
      'ativo':false
   },
   {
      'id':295,
      'nome':'295 - BANCO CREDIPLAN S.A',
      'ativo':false
   },
   {
      'id':300,
      'nome':'300 - BANCO DE LA NACION ARGENTINA S.A',
      'ativo':false
   },
   {
      'id':302,
      'nome':'302 - BANCO DO PROGRESSO S.A',
      'ativo':false
   },
   {
      'id':303,
      'nome':'303 - BANCO HNF S.A.',
      'ativo':false
   },
   {
      'id':304,
      'nome':'304 - BANCO PONTUAL S.A',
      'ativo':false
   },
   {
      'id':308,
      'nome':'308 - BANCO COMERCIAL BANCESA S.A.',
      'ativo':false
   },
   {
      'id':318,
      'nome':'318 - BANCO B.M.G. S.A',
      'ativo':false
   },
   {
      'id':320,
      'nome':'320 - BANCO INDUSTRIAL E COMERCIAL',
      'ativo':false
   },
   {
      'id':341,
      'nome':'341 - BANCO ITAU S.A',
      'ativo':true,
      'paymentMethod': 'ITAU_TRANSFER_PJ'
   },
   {
      'id':346,
      'nome':'346 - BANCO FRANCES E BRASILEIRO S.A',
      'ativo':false
   },
   {
      'id':347,
      'nome':'347 - BANCO SUDAMERIS BRASIL S.A',
      'ativo':false
   },
   {
      'id':351,
      'nome':'351 - BANCO BOZANO SIMONSEN S.A',
      'ativo':false
   },
   {
      'id':353,
      'nome':'353 - BANCO GERAL DO COMERCIO S.A',
      'ativo':false
   },
   {
      'id':356,
      'nome':'356 - ABN AMRO S.A',
      'ativo':false
   },
   {
      'id':366,
      'nome':'366 - BANCO SOGERAL S.A',
      'ativo':false
   },
   {
      'id':369,
      'nome':'369 - PONTUAL',
      'ativo':false
   },
   {
      'id':370,
      'nome':'370 - BEAL - BANCO EUROPEU PARA AMERICA LATINA',
      'ativo':false
   },
   {
      'id':372,
      'nome':'372 - BANCO ITAMARATI S.A',
      'ativo':false
   },
   {
      'id':375,
      'nome':'375 - BANCO FENICIA S.A',
      'ativo':false
   },
   {
      'id':376,
      'nome':'376 - CHASE MANHATTAN BANK S.A',
      'ativo':false
   },
   {
      'id':388,
      'nome':'388 - BANCO MERCANTIL DE DESCONTOS S/A',
      'ativo':false
   },
   {
      'id':389,
      'nome':'389 - BANCO MERCANTIL DO BRASIL S.A',
      'ativo':false
   },
   {
      'id':392,
      'nome':'392 - BANCO MERCANTIL DE SAO PAULO S.A',
      'ativo':false
   },
   {
      'id':394,
      'nome':'394 - BANCO B.M.C. S.A',
      'ativo':false
   },
   {
      'id':399,
      'nome':'399 - BANCO BAMERINDUS DO BRASIL S.A',
      'ativo':false
   },
   {
      'id':409,
      'nome':'409 - UNIBANCO - UNIAO DOS BANCOS BRASILEIROS',
      'ativo':false
   },
   {
      'id':412,
      'nome':'412 - BANCO NACIONAL DA BAHIA S.A',
      'ativo':false
   },
   {
      'id':415,
      'nome':'415 - BANCO NACIONAL S.A',
      'ativo':false
   },
   {
      'id':420,
      'nome':'420 - BANCO NACIONAL DO NORTE S.A',
      'ativo':false
   },
   {
      'id':422,
      'nome':'422 - BANCO SAFRA S.A',
      'ativo':false
   },
   {
      'id':424,
      'nome':'424 - BANCO NOROESTE S.A',
      'ativo':false
   },
   {
      'id':434,
      'nome':'434 - BANCO FORTALEZA S.A',
      'ativo':false
   },
   {
      'id':453,
      'nome':'453 - BANCO RURAL S.A',
      'ativo':false
   },
   {
      'id':456,
      'nome':'456 - BANCO TOKIO S.A',
      'ativo':false
   },
   {
      'id':464,
      'nome':'464 - BANCO SUMITOMO BRASILEIRO S.A',
      'ativo':false
   },
   {
      'id':466,
      'nome':'466 - BANCO MITSUBISHI BRASILEIRO S.A',
      'ativo':false
   },
   {
      'id':472,
      'nome':'472 - LLOYDS BANK PLC',
      'ativo':false
   },
   {
      'id':473,
      'nome':'473 - BANCO FINANCIAL PORTUGUES S.A',
      'ativo':false
   },
   {
      'id':477,
      'nome':'477 - CITIBANK N.A',
      'ativo':false
   },
   {
      'id':479,
      'nome':'479 - BANCO DE BOSTON S.A',
      'ativo':false
   },
   {
      'id':480,
      'nome':'480 - BANCO PORTUGUES DO ATLANTICO-BRASIL S.A',
      'ativo':false
   },
   {
      'id':483,
      'nome':'483 - BANCO AGRIMISA S.A.',
      'ativo':false
   },
   {
      'id':487,
      'nome':'487 - DEUTSCHE BANK S.A - BANCO ALEMAO',
      'ativo':false
   },
   {
      'id':488,
      'nome':'488 - BANCO J. P. MORGAN S.A',
      'ativo':false
   },
   {
      'id':489,
      'nome':'489 - BANESTO BANCO URUGAUAY S.A',
      'ativo':false
   },
   {
      'id':492,
      'nome':'492 - INTERNATIONALE NEDERLANDEN BANK N.V.',
      'ativo':false
   },
   {
      'id':493,
      'nome':'493 - BANCO UNION S.A.C.A',
      'ativo':false
   },
   {
      'id':494,
      'nome':'494 - BANCO LA REP. ORIENTAL DEL URUGUAY',
      'ativo':false
   },
   {
      'id':495,
      'nome':'495 - BANCO LA PROVINCIA DE BUENOS AIRES',
      'ativo':false
   },
   {
      'id':496,
      'nome':'496 - BANCO EXTERIOR DE ESPANA S.A',
      'ativo':false
   },
   {
      'id':498,
      'nome':'498 - CENTRO HISPANO BANCO',
      'ativo':false
   },
   {
      'id':499,
      'nome':'499 - BANCO IOCHPE S.A',
      'ativo':false
   },
   {
      'id':501,
      'nome':'501 - BANCO BRASILEIRO IRAQUIANO S.A.',
      'ativo':false
   },
   {
      'id':502,
      'nome':'502 - BANCO SANTANDER S.A',
      'ativo':true,
      'paymentMethod': 'SANTANDER_TRANSFER'
   },
   {
      'id':504,
      'nome':'504 - BANCO MULTIPLIC S.A',
      'ativo':false
   },
   {
      'id':505,
      'nome':'505 - BANCO GARANTIA S.A',
      'ativo':false
   },
   {
      'id':600,
      'nome':'600 - BANCO LUSO BRASILEIRO S.A',
      'ativo':false
   },
   {
      'id':601,
      'nome':'601 - BFC BANCO S.A.',
      'ativo':false
   },
   {
      'id':602,
      'nome':'602 - BANCO PATENTE S.A',
      'ativo':false
   },
   {
      'id':604,
      'nome':'604 - BANCO INDUSTRIAL DO BRASIL S.A',
      'ativo':false
   },
   {
      'id':607,
      'nome':'607 - BANCO SANTOS NEVES S.A',
      'ativo':false
   },
   {
      'id':608,
      'nome':'608 - BANCO OPEN S.A',
      'ativo':false
   },
   {
      'id':610,
      'nome':'610 - BANCO V.R. S.A',
      'ativo':false
   },
   {
      'id':611,
      'nome':'611 - BANCO PAULISTA S.A',
      'ativo':false
   },
   {
      'id':612,
      'nome':'612 - BANCO GUANABARA S.A',
      'ativo':false
   },
   {
      'id':613,
      'nome':'613 - BANCO PECUNIA S.A',
      'ativo':false
   },
   {
      'id':616,
      'nome':'616 - BANCO INTERPACIFICO S.A',
      'ativo':false
   },
   {
      'id':617,
      'nome':'617 - BANCO INVESTOR S.A.',
      'ativo':false
   },
   {
      'id':618,
      'nome':'618 - BANCO TENDENCIA S.A',
      'ativo':false
   },
   {
      'id':621,
      'nome':'621 - BANCO APLICAP S.A.',
      'ativo':false
   },
   {
      'id':622,
      'nome':'622 - BANCO DRACMA S.A',
      'ativo':false
   },
   {
      'id':623,
      'nome':'623 - BANCO PANAMERICANO S.A',
      'ativo':false
   },
   {
      'id':624,
      'nome':'624 - BANCO GENERAL MOTORS S.A',
      'ativo':false
   },
   {
      'id':625,
      'nome':'625 - BANCO ARAUCARIA S.A',
      'ativo':false
   },
   {
      'id':626,
      'nome':'626 - BANCO FICSA S.A',
      'ativo':false
   },
   {
      'id':627,
      'nome':'627 - BANCO DESTAK S.A',
      'ativo':false
   },
   {
      'id':628,
      'nome':'628 - BANCO CRITERIUM S.A',
      'ativo':false
   },
   {
      'id':629,
      'nome':'629 - BANCORP BANCO COML. E. DE INVESTMENTO',
      'ativo':false
   },
   {
      'id':630,
      'nome':'630 - BANCO INTERCAP S.A',
      'ativo':false
   },
   {
      'id':633,
      'nome':'633 - BANCO REDIMENTO S.A',
      'ativo':false
   },
   {
      'id':634,
      'nome':'634 - BANCO TRIANGULO S.A',
      'ativo':false
   },
   {
      'id':635,
      'nome':'635 - BANCO DO ESTADO DO AMAPA S.A',
      'ativo':false
   },
   {
      'id':637,
      'nome':'637 - BANCO SOFISA S.A',
      'ativo':false
   },
   {
      'id':638,
      'nome':'638 - BANCO PROSPER S.A',
      'ativo':false
   },
   {
      'id':639,
      'nome':'639 - BIG S.A. - BANCO IRMAOS GUIMARAES',
      'ativo':false
   },
   {
      'id':640,
      'nome':'640 - BANCO DE CREDITO METROPOLITANO S.A',
      'ativo':false
   },
   {
      'id':641,
      'nome':'641 - BANCO EXCEL ECONOMICO S/A',
      'ativo':false
   },
   {
      'id':643,
      'nome':'643 - BANCO SEGMENTO S.A',
      'ativo':false
   },
   {
      'id':645,
      'nome':'645 - BANCO DO ESTADO DE RORAIMA S.A',
      'ativo':false
   },
   {
      'id':647,
      'nome':'647 - BANCO MARKA S.A',
      'ativo':false
   },
   {
      'id':648,
      'nome':'648 - BANCO ATLANTIS S.A',
      'ativo':false
   },
   {
      'id':649,
      'nome':'649 - BANCO DIMENSAO S.A',
      'ativo':false
   },
   {
      'id':650,
      'nome':'650 - BANCO PEBB S.A',
      'ativo':false
   },
   {
      'id':652,
      'nome':'652 - BANCO FRANCES E BRASILEIRO SA',
      'ativo':false
   },
   {
      'id':653,
      'nome':'653 - BANCO INDUSVAL S.A',
      'ativo':false
   },
   {
      'id':654,
      'nome':'654 - BANCO A. J. RENNER S.A',
      'ativo':false
   },
   {
      'id':655,
      'nome':'655 - BANCO VOTORANTIM S.A.',
      'ativo':false
   },
   {
      'id':656,
      'nome':'656 - BANCO MATRIX S.A',
      'ativo':false
   },
   {
      'id':657,
      'nome':'657 - BANCO TECNICORP S.A',
      'ativo':false
   },
   {
      'id':658,
      'nome':'658 - BANCO PORTO REAL S.A',
      'ativo':false
   },
   {
      'id':702,
      'nome':'702 - BANCO SANTOS S.A',
      'ativo':false
   },
   {
      'id':705,
      'nome':'705 - BANCO INVESTCORP S.A.',
      'ativo':false
   },
   {
      'id':707,
      'nome':'707 - BANCO DAYCOVAL S.A',
      'ativo':false
   },
   {
      'id':711,
      'nome':'711 - BANCO VETOR S.A.',
      'ativo':false
   },
   {
      'id':713,
      'nome':'713 - BANCO CINDAM S.A',
      'ativo':false
   },
   {
      'id':715,
      'nome':'715 - BANCO VEGA S.A',
      'ativo':false
   },
   {
      'id':718,
      'nome':'718 - BANCO OPERADOR S.A',
      'ativo':false
   },
   {
      'id':719,
      'nome':'719 - BANCO PRIMUS S.A',
      'ativo':false
   },
   {
      'id':720,
      'nome':'720 - BANCO MAXINVEST S.A',
      'ativo':false
   },
   {
      'id':721,
      'nome':'721 - BANCO CREDIBEL S.A',
      'ativo':false
   },
   {
      'id':722,
      'nome':'722 - BANCO INTERIOR DE SAO PAULO S.A',
      'ativo':false
   },
   {
      'id':724,
      'nome':'724 - BANCO PORTO SEGURO S.A',
      'ativo':false
   },
   {
      'id':725,
      'nome':'725 - BANCO FINABANCO S.A',
      'ativo':false
   },
   {
      'id':726,
      'nome':'726 - BANCO UNIVERSAL S.A',
      'ativo':false
   },
   {
      'id':728,
      'nome':'728 - BANCO FITAL S.A',
      'ativo':false
   },
   {
      'id':729,
      'nome':'729 - BANCO FONTE S.A',
      'ativo':false
   },
   {
      'id':730,
      'nome':'730 - BANCO COMERCIAL PARAGUAYO S.A',
      'ativo':false
   },
   {
      'id':731,
      'nome':'731 - BANCO GNPP S.A.',
      'ativo':false
   },
   {
      'id':732,
      'nome':'732 - BANCO PREMIER S.A.',
      'ativo':false
   },
   {
      'id':733,
      'nome':'733 - BANCO NACOES S.A.',
      'ativo':false
   },
   {
      'id':734,
      'nome':'734 - BANCO GERDAU S.A',
      'ativo':false
   },
   {
      'id':735,
      'nome':'735 - BACO POTENCIAL',
      'ativo':false
   },
   {
      'id':736,
      'nome':'736 - BANCO UNITED S.A',
      'ativo':false
   },
   {
      'id':737,
      'nome':'737 - THECA',
      'ativo':false
   },
   {
      'id':738,
      'nome':'738 - MARADA',
      'ativo':false
   },
   {
      'id':739,
      'nome':'739 - BGN',
      'ativo':false
   },
   {
      'id':740,
      'nome':'740 - BCN BARCLAYS',
      'ativo':false
   },
   {
      'id':741,
      'nome':'741 - BRP',
      'ativo':false
   },
   {
      'id':742,
      'nome':'742 - EQUATORIAL',
      'ativo':false
   },
   {
      'id':743,
      'nome':'743 - BANCO EMBLEMA S.A',
      'ativo':false
   },
   {
      'id':744,
      'nome':'744 - THE FIRST NATIONAL BANK OF BOSTON',
      'ativo':false
   },
   {
      'id':745,
      'nome':'745 - CITIBAN N.A.',
      'ativo':false
   },
   {
      'id':746,
      'nome':'746 - MODAL S\\A',
      'ativo':false
   },
   {
      'id':747,
      'nome':'747 - RAIBOBANK DO BRASIL',
      'ativo':false
   },
   {
      'id':748,
      'nome':'748 - SICREDI',
      'ativo':false
   },
   {
      'id':749,
      'nome':'749 - BRMSANTIL SA',
      'ativo':false
   },
   {
      'id':750,
      'nome':'750 - BANCO REPUBLIC NATIONAL OF NEW YORK (BRA',
      'ativo':false
   },
   {
      'id':751,
      'nome':'751 - DRESDNER BANK LATEINAMERIKA-BRASIL S/A',
      'ativo':false
   },
   {
      'id':752,
      'nome':'752 - BANCO BANQUE NATIONALE DE PARIS BRASIL S',
      'ativo':false
   },
   {
      'id':753,
      'nome':'753 - BANCO COMERCIAL URUGUAI S.A.',
      'ativo':false
   },
   {
      'id':755,
      'nome':'755 - BANCO MERRILL LYNCH S.A',
      'ativo':false
   },
   {
      'id':756,
      'nome':'756 - BANCO COOPERATIVO DO BRASIL S.A.',
      'ativo':false
   },
   {
      'id':757,
      'nome':'757 - BANCO KEB DO BRASIL S.A.',
      'ativo':false
   },
   {
      'id':77,
      'nome':'077 - BANCO INTER S.A. (INTERMEDIUM)',
      'ativo':true,
      'paymentMethod': 'INTER_TRANSFER'
   }
]

export default bancos



// WEBPACK FOOTER //
// ./src/vuex/cache/bancos.js